export default __webpack_public_path__ + "static/people_02-f175ee2d70aa75b3ebc02a6d810b745e.png";